<template>
  <div class="category-section">
    <div class="category-header">
      <div class="category-title">
        <img :src="fullImg(this.category.img)" alt="icon" class="category-icon" />
        <h3>{{ this.category.name }}</h3>
      </div>
      <div class="category-controls">
           <button
    v-if="!['rivo-originals','hot','favorites'].includes(category.slug)"
    class="see-all"
    @click="goToCategory(this.category.slug)"
  >
    {{ $t('home.See All') }} 
    ({{ typeof this.category.total_games === 'number' 
        ? this.category.total_games 
        : this.category.games.length }})
  </button>

       <button
    class="arrow left"
    :class="{ disabled: atStart }"
    @click="scroll('left')"
  >
    &lt;
  </button>
  <button
    class="arrow right"
    :class="{ disabled: atEnd }"
    @click="scroll('right')"
  >
    &gt;
  </button>

      
      </div>
    </div>

    <div
      class="game-list"
      ref="scrollRef"
      @mousedown="startDrag"
      @mousemove="onDrag"
      @mouseup="stopDrag"
      @mouseleave="stopDrag"
    >
      <div
        v-for="game in this.category.games"
        :key="(this.category.slug === 'favorites' ? 'fav-' : '') + game._id"
        class="game-card"
        @mouseenter="hovered = game._id"
        @mouseleave="hovered = null"
        @click="launchGame(game)"
      >
       <div class="img-wrapper">
  <!-- LOGO banner-card'ın DIŞINDA -->
  <div class="game-logo">
    <img src="@/assets/img/gamelogo.png" alt="logo" />
  </div>

  <div class="banner-card">
  <img
  :src="fullImg(game.banner)"
  class="banner"
  loading="eager"
  decoding="async"
  fetchpriority="high"
 
/>
  </div>
</div>


        <div class="game-info">
          <div class="top">
            <span class="provider">{{ game.provider?.name || game.provider_code }}</span>
            <span
              class="favorite"
              :class="{ active: favorites.includes(game._id) }"
              @click.stop="onToggleFavorite(game._id)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                :fill="favorites.includes(game._id) ? '#ffea2f' : '#1f3636'">
                <path
                  d="M22,10.1c0.1-0.5-0.3-1.1-0.8-1.1l-5.7-0.8L12.9,3c-0.1-0.2-0.2-0.3-0.4-0.4C12,2.3,11.4,2.5,11.1,3L8.6,8.2L2.9,9
                    C2.6,9,2.4,9.1,2.3,9.3c-0.4,0.4-0.4,1,0,1.4l4.1,4l-1,5.7c0,0.2,0,0.4,0.1,0.6c0.3,0.5,0.9,0.7,1.4,0.4l5.1-2.7l5.1,2.7
                    c0.1,0.1,0.3,0.1,0.5,0.1v0c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.6,0.8-1.2l-1-5.7l4.1-4C21.9,10.5,22,10.3,22,10.1z"
                />
              </svg>
            </span>
          </div>
          <div class="bottom">
            <span class="name">{{ shortName(game.game_name) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategorySection',
  props: {
    category: Object,
    favorites: Array,
    onToggleFavorite: Function,
    loading: Boolean,
    isRivoOriginals: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      scrollStart: 0,
      hovered: null,
      atStart: true,
    atEnd: false,
    };
  },
  mounted() {
  this.checkScrollEdges()
  this.$refs.scrollRef.addEventListener('scroll', this.checkScrollEdges)
},
beforeUnmount() {
  this.$refs.scrollRef.removeEventListener('scroll', this.checkScrollEdges)
},
  methods: {
     scroll(direction) {
    const el = this.$refs.scrollRef
    const card = el.querySelector('.game-card')
    const step = card ? card.offsetWidth + 10 : 300
    const amount = direction === 'left' ? -step : step
    el.scrollBy({ left: amount, behavior: 'smooth' })
  },
  checkScrollEdges() {
    const el = this.$refs.scrollRef
    this.atStart = el.scrollLeft <= 0
    this.atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth
  },
launchGame(game) {
  if (this.isRivoOriginals) {
    const routeMap = {
      crash: 'Crash',
      roll: 'Roll',
      blackjack: 'Blackjack',
      duels: 'Duels',
      mines: 'Mines',
      towers: 'Towers',
      unbox: 'UnboxOverview',
      turbo: 'TurboTrade',
      wingo: 'Wingo'
    };

    const slug = (game.slug || game.route || '').toLowerCase();
    const routeName = routeMap[slug];

    if (routeName) {
      this.$router.push({ name: routeName });
    } else {
      console.warn('Bu Rivo oyunu desteklenmiyor:', game.game_name, `(${slug})`);
    }
  } else {
    this.$router.push({ name: 'GameStart', params: { id: game.game_code } });
  }
},

    fullImg(path) {
      if (!path) return '';
      if (path.startsWith('http')) return path;
      return process.env.VUE_APP_BACKEND_URL + path;
    },
    shortName(name) {
      return name.length > 18 ? name.slice(0, 18) + '...' : name;
    },
    scroll(direction) {
      const el = this.$refs.scrollRef;
      const amount = direction === 'left' ? -300 : 300;
      el.scrollBy({ left: amount, behavior: 'smooth' });
    },
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.pageX - this.$refs.scrollRef.offsetLeft;
      this.scrollStart = this.$refs.scrollRef.scrollLeft;
    },
    onDrag(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      const x = e.pageX - this.$refs.scrollRef.offsetLeft;
      const walk = (x - this.startX) * 2;
      this.$refs.scrollRef.scrollLeft = this.scrollStart - walk;
    },
    stopDrag() {
      this.isDragging = false;
    },
    goToCategory(slug) {
      this.$router.push({ name: 'Category', params: { slug } });
    }
  }
};
</script>

<style scoped>
.category-section {
  
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
   
}

.category-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.category-icon {
  width: 28px;
  height: 28px;
}

.category-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

 
.see-all {
  background: linear-gradient(to bottom, #01e0a3 0%, #00aa6d 95%, transparent 60%),
              linear-gradient(to bottom, #3a6d5f, #3a6d5f);
  border: none;
  padding: 6px 12px;
  color: black;
  font-weight: bold;
  cursor: pointer;
}

.arrow {
  border: none;
  padding: 6px 12px;
  font-weight: bold;
  cursor: pointer;
  color: white;
  transition: background 0.3s;
}

/* Aktif */
.arrow.left {
  border-radius: 6px 0 0 6px;
  background: var(--active-button);
      height: 35px;
}
.arrow.right {
  border-radius: 0 6px 6px 0;
  background: var(--active-button);
      height: 35px;
}

/* Pasif (scroll başında veya sonunda) */
.arrow.left.disabled {
  background: var(--deactive-button); /* gri ton */
  cursor: not-allowed;
      height: 35px;
}
.arrow.right.disabled {
  background: var(--deactive-button);
  cursor: not-allowed;
      height: 35px;
}

/* See all */
.see-all {
  border-radius: 6px;
      height: 35px;
  background: var(--active-button);
  color: white;
}


/* See all butonu (her taraf yuvarlak) */
.see-all {
  border-radius: 6px; /* normal yuvarlak */
}


.game-list {
  display: flex;
  overflow-x: auto;
  overflow-y: visible; /* 🔥 KRİTİK */
  gap: 10px;
  padding-bottom: 10px;
  position: relative;
      padding-top: 12px;
}



.game-card {
  flex-shrink: 0;
  width: 210px;
  border-radius: 12px;
   
  position: relative;
  background: none;
  transition: transform 0.3s ease, z-index 0.3s ease;
  
}

 

.img-wrapper {
  position: relative;
  border-radius: 14px;
overflow: visible;
  /* BORDER */
  border: 4px solid var(--outline);
  
 
}


.banner-card {
  position: relative;
  border-radius: 10px;
  
 
}



.banner {
  width: 100%;
  height: 158px;

  display: block;
  border-radius: 10px;
  position: relative;
 
}

 

.game-info {
  padding: 8px 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.top {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #aaa;
}

.favorite {
  cursor: pointer;
  color: #666;
}

.favorite.active {
  color: red;
}

.category-title h3 {
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.bottom {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  color: white;
}

@media (max-width: 1024px) {
.category-section {
  padding-left: 10px;
  padding-right: 10px;
}

.game-card {
  flex-shrink: 0;
  width: 146px;
 
  border-radius: 12px;
  overflow: visible;
  position: relative;
  background: none;
  transition: transform 0.3s ease, z-index 0.3s ease;
}

.banner {
  width: 100%;
  height: 116px;
 
  display: block;
  border-radius: 10px;
  position: relative;
  z-index: -1;
}


 


}

.game-logo {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 20;
 
  padding: 4px 10px;
  border-radius: 16px;

 
}
.game-logo img {
  height: 35px;
  width: auto;
  display: block;
}

</style>
